// Cámara (documento 07). En la PWA, un input de archivo con `capture=environment` abre la cámara trasera.
// Con Capacitor se reemplaza por @capacitor/camera con la misma interfaz.
import { comprimirFoto } from '../datos/archivos';

export interface Foto {
  blob: Blob;
  ancho: number;
  alto: number;
  url: string;
}

export interface ServicioCamara {
  sacarFoto(): Promise<Foto | null>;
}

class CamaraWeb implements ServicioCamara {
  sacarFoto(): Promise<Foto | null> {
    return new Promise((resolve) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.setAttribute('capture', 'environment');
      input.onchange = async () => {
        const f = input.files?.[0];
        if (!f) return resolve(null);
        try {
          const c = await comprimirFoto(f);
          resolve({ ...c, url: URL.createObjectURL(c.blob) });
        } catch {
          resolve(null);
        }
      };
      input.click();
    });
  }
}

export const camara: ServicioCamara = new CamaraWeb();
